'use strict';

/**
 * BD.TourBrowser: Retrieve all tours, then display them according to user-selected filters.
 */

var BD = window.BD = window.BD || {};
BD.TourBrowser = (function($) {
  var DISPLAY_PAGE_SIZE = 12;

  var $tourBrowser;
  var $filterbar;
  var $results;
  var $allTours;
  var $filteredTours;
  var pagination = null;
  var weekdayBlackouts;
  
  var $catFilter;
  var $btnThisWeekend;
  var $btnNextWeekend;
  var $btnThisMonth;
  var $startDateFilter;
  var $endDateFilter;
  var $pagination;
  var $selectedDates;
  var $weekdayProduct = null;
  
  var lastRetrievedPage = 0;
  var pagesComplete = false;
  var loading = false;
  
  // These date ranges are formatted { start: '2019-01-01', end: '2019-01-31' }
  var thisWeekendDateRange;
  var nextWeekendDateRange;
  var thisMonthDateRange;

  var prettyDateOptions = { month: 'long', day: 'numeric', year: 'numeric' };
  
  var initialized = false;

  /**
   * Retrieve the next (or first) page of the tours, cache the results, and
   * start loading the next page.
   */
  function loadNextPage() 
  {
    if (pagesComplete || loading) {
      return;
    }
    
    loading = true;
    lastRetrievedPage++;
    
    var url = '/collections/ott?view=raw&page=' + lastRetrievedPage;

    $.ajax(url, 
    {
      success: (response) => 
      {
        // TODO: Consider using BD.CollectionLoader instead.
        if (response.trim()) 
        {
          $allTours.append(response);
          var $hasMoreIndicator = $allTours.find('span.more-indicator');

          if ($hasMoreIndicator.length) {
            window.setTimeout(() => loadNextPage(), 1);
          }
          else {
            pagesComplete = true;
          }
          
          $hasMoreIndicator.remove();
        }
        // No content in response
        else {
          pagesComplete = true;
        }
        
        if (pagesComplete) {
          loading = false;
          $allTours.trigger('loading-complete');
        }
      },
      complete: () => 
      {
        loading = false;
        refreshResults();
      }
    });
  }
  
  function loadWeekdayProduct() {
    if (!window.BD.weekdayTourData || !window.BD.weekdayTourData.productUrl) { return; }
    
    const url = `${ window.BD.weekdayTourData.productUrl }?view=raw`;
    
    $.ajax(url, {
      success: (response) => {
        const html = response.trim();
        
        if (!html) { return; }
        $weekdayProduct = $(html);
        refreshResults();
      }
    });
  }
  
  function onLoadingComplete(callback) {
    var fnCallback = () => callback($allTours.find('.card-ui'));
    
    if (pagesComplete) { fnCallback(); }
    $allTours.on('loading-complete', fnCallback);
  }
  
  function ensureAllToursExists() {
    if (!$allTours || !$allTours.length) {
      $allTours = $('#tours__all');

      if (!$allTours || !$allTours.length) {
        $allTours = $('<div style="display: none"></div>').appendTo('body');
      }
    }
  }
  
  function refreshResults() {
    var selectedCategory = $catFilter.val();
    var startYmd = ($startDateFilter.val() || '').replace(/-/g, '');
    var endYmd = ($endDateFilter.val() || '').replace(/-/g, '');

    var $tours = $allTours.children();
    
    $tours.each((idx, tour) => {
      const dateStr = tour.querySelector('.card-ui').dataset.tourYmd;
      const dateTimeStr = `${ dateStr.substr(0, 4) }-${ dateStr.substr(4, 2) }-${ dateStr.substr(6, 2) }T00:00:00.000Z`;
      const date = new Date(dateTimeStr);
      tour.tourDate = date;
    });
    
    var dateRe = /[0-9]{8}/;
    var hasDate = !!(startYmd || endYmd);
    
    $selectedDates.toggleClass('shown', hasDate);
    
    if (hasDate) {
      var startNumeric = startYmd ? parseInt(startYmd) : null;
      var endNumeric = endYmd ? parseInt(endYmd) : null;
      
      $tours = $tours.filter((idx, el) => {
        var ymd = '' + $(el).find('.card-ui').data('tour-ymd');

        if( !ymd ) return false;
        if (!ymd.match(dateRe)) { return false; }
        
        ymd = parseInt(ymd);
        return (!startNumeric || startNumeric <= ymd) && (!endNumeric || endNumeric >= ymd);
      });
    }    
    
    var startStr = getPrettyStart();
    var endStr = getPrettyEnd();
    var desc = '';
    var descLabel = '';
    
    if (startStr && endStr) {
      descLabel = 'From';
      desc = startStr + ' - ' + endStr;
    }
    else if (startStr) {
      descLabel = 'From';
      desc = startStr; 
    }
    else if (endStr) {
      descLabel = 'Before';
      desc = endStr; 
    }

    if (desc) {
      $selectedDates.find('.dateFilter__selectedDateDesc').text(desc);
      $selectedDates.find('.dateFilter__selectedDateDescLabel').text(descLabel);
    }
    

    if (selectedCategory) 
    {
      $tours = $tours.filter((idx, el) => 
      {
        var cats = $(el).find('.card-ui').data('tour-cats');
        if( !cats ) return false;
        cats = cats.split(',');
        return cats.includes(selectedCategory);
      });
    }
    
    const sortFnByDate = (a, b) => {
      var ymdA = '' + $(a).find('.card-ui').data('tour-ymd');
      var ymdB = '' + $(b).find('.card-ui').data('tour-ymd');

      if (ymdA == ymdB) { return 0; }
      if (!ymdA) { return 1; }
      if (!ymdB) { return -1; }
      
      return ymdA.localeCompare(ymdB);
    };
    
    $tours = $tours.sort(sortFnByDate);

    /**
     * If weekday tours are configured, insert one between every weekend.  "Weekend"
     * is the first non-zero (Sunday) day per week. 
     */    
    if ($weekdayProduct && $tours.length) {
      const firstTourDate = $tours.first()[0].tourDate;
      const lastTourDate = $tours.last()[0].tourDate;
      const weekdayTourNodes = createWeekdayTourNodes(firstTourDate, lastTourDate);
      
      weekdayTourNodes.forEach(tour => $tours = $tours.add(tour));
      $tours = $tours.sort(sortFnByDate);
    }
      
    $filteredTours = $tours;
    
    pagination = newPagination($filteredTours.length);
    displayPage(0);
  }
  
  function createWeekdayTourNodes(startDate, endDate) {
    const curDate = new Date(startDate);
    const endTstamp = endDate.getTime();
    const tourNodes = [];
    
    // Start on a Sunday
    curDate.setUTCDate(curDate.getUTCDate() - curDate.getUTCDay());
   
    while (curDate.getTime() < endTstamp) {
      const node = createWeekdayTourNode(curDate);
      
      if (node) { tourNodes.push(node); }
      curDate.setUTCDate(curDate.getUTCDate() + 7);
    }
    
    // Add a final tour after the last date
    const node = createWeekdayTourNode(curDate);
    if (node) { tourNodes.push(node); }
    
    return tourNodes;
  }
  
  function createWeekdayTourNode(date) {
    const availableDateHtml = buildWeekdayTourAvailableDateHtml(date);
    
    // If all the dates are blacked out, don't add a weekday tour
    if (!availableDateHtml) { return null; }

    // Set tour dates to Wednesday so they appear appropriately in the calendar
    const tourDate = new Date(date);
    tourDate.setUTCDate(tourDate.getUTCDate() + 3);
    
    const tourNode = $weekdayProduct[0].cloneNode(true);
    tourNode.tourDate = tourDate;
    
    const tourYmd = `${ tourDate.getUTCFullYear() }${ (tourDate.getUTCMonth() + 1).toString().padStart(2, '0') }${ tourDate.getUTCDate().toString().padStart(2, '0') }`;
    tourNode.querySelector('.card-ui').setAttribute('data-tour-ymd', tourYmd);
    tourNode.querySelector('.date__text').innerHTML = availableDateHtml;
    tourNode.querySelector('.time__text').innerHTML = window.BD.weekdayTourData.timeLabel;

    return tourNode;
  }
  
  function populateNoResultsMessage() {
    var msg = "No results found";
    var endYmd = $endDateFilter.val();
    var startStr = getPrettyStart();
    var endStr = getPrettyEnd();

    if (startStr && endStr) {
      msg += " between " + startStr + ' and ' + endStr;
    }
    else if (startStr) {
      msg += " after " + startStr;
    }
    else if (endStr) {
      msg += " before " + endStr;
    }

    $tourBrowser.find('#tourBrowser__noResults').text(msg);
  }    
  
  /**
   * Updates the results and pagination panels based on the "$filteredTours"
   * and "pagination" variables. 
   */
  function displayPage(pageNum) {
    var noResults = (pagination.itemCount == 0);
    var noPages = (pagination.numPages <= 1);

    $tourBrowser.toggleClass('no-results', noResults);
    $tourBrowser.toggleClass('no-pages', noPages);
    $results.empty();
    
    if (noResults) {
      populateNoResultsMessage();
      return; 
    }

    pageNum = Math.max(pageNum, 0);
    pageNum = Math.min(pageNum, pagination.numPages - 1);
    pagination.currentPage = pageNum;

    var itemOffset = pageNum * DISPLAY_PAGE_SIZE;
    var $pageItems = $filteredTours.slice(itemOffset, itemOffset + DISPLAY_PAGE_SIZE);
    $results.append($pageItems.clone());
    
    const isFirst = (pageNum == 0);
    const isLast = (pageNum == pagination.numPages - 1);
    
    $pagination.find('.btn--prev')
      .toggleClass('disabled', isFirst)
      .attr('disabled', isFirst)
      .off('click')
      .on('click', () => displayPage(pageNum - 1));
    
    $pagination.find('.btn--next')
      .toggleClass('disabled', isLast)
      .attr('disabled', isLast)
      .off('click')
      .on('click', () => displayPage(pageNum + 1));

    $pagination.find('.btn--pageButton').remove();
    
    var $pageButtonTemplate = $pagination.find('.btn--pageButtonTemplate');
    var $buttonInsertCursor = $pageButtonTemplate;

    for (var i = 0; i < pagination.numPages; i++) {
      var isSelected = (pageNum == i);
      var pageOnClick = i;
      var $pageButton = $pageButtonTemplate.clone()
        .removeClass('btn--pageButtonTemplate')
        .addClass('btn--pageButton')
        .toggleClass('selected', isSelected)
        .attr('bd-pageNum', i)
        .on('click', (e) => displayPage(e.currentTarget.getAttribute('bd-pageNum')))
        .show();

      $pageButton.find('.pageNumber').text(i + 1);
      $pageButton.insertAfter($buttonInsertCursor);
      $buttonInsertCursor = $pageButton;
    }
  }
  
  function buildWeekdayTourAvailableDateHtml(nextTourDate) {
    const dates = [];
    const curDate = new Date(nextTourDate.getTime());
    curDate.setUTCDate(curDate.getUTCDate() - curDate.getUTCDay());

    // Build one week of tour days, starting on Sunday
    for (var i = 0; i < 7; i++) {
      const newDate = new Date(curDate.getTime());
      newDate.setUTCDate(newDate.getUTCDate() + i);
      dates.push(newDate);
    }

    const tagStart = '<span class="weekdayTour__availableDate">';
    const tagEnd = '</span>';
    const dateStr = weekdayBlackouts.buildDateStr(dates, `${ tagEnd }${ tagStart }`);
    return dateStr ? (tagStart + dateStr + tagEnd) : ''; 
  }
  
  function newPagination(itemCount) {
    return {
      itemCount: itemCount,
      numPages: Math.ceil(itemCount / DISPLAY_PAGE_SIZE),
      currentPage: 0
    };
  }
  
  function getDateRangeStructure(startDate, endDate) {
    var startDateISO = startDate.toISOString().substr(0, 10);
    var endDateISO = endDate.toISOString().substr(0, 10);
    
    return {
      start: startDateISO,
      end: endDateISO
    };
  }

  /**
   * Finds the weekend date range for a specific date.  Weekends span 3 days (Fri-Sun).
   * 
   * For Mon-Thu, the weekend starts on the next Friday.  
   * For Fri-Sat, the weekend starts on the current/prior Friday.
   * 
   * @param date Date
   */
  function weekendDateRangeFromDate(date) {
    var weekendStart = new Date(date);
    var weekendEnd = new Date(date);
    
    // day-of-month for the weekend to start.  May end up <0 or >31 but
    // it gets automatically normalized later.
    var lastSundayDate = date.getUTCDate() - date.getUTCDay();
    var nextFridayDate = lastSundayDate + 5;
    var nextSundayDate = lastSundayDate + 7;
    
    weekendStart.setUTCDate(nextFridayDate);
    weekendEnd.setUTCDate(nextSundayDate);
    
    return getDateRangeStructure(weekendStart, weekendEnd);
  }
  
  function getPrettyStart() {
    var startYmd = $startDateFilter.val();
    return (startYmd ? new Date(Date.parse(startYmd)).toLocaleDateString('en-US', prettyDateOptions) : null); 
  }
  
  function getPrettyEnd() {
    var endYmd = $endDateFilter.val();
    return (endYmd ? new Date(Date.parse(endYmd)).toLocaleDateString('en-US', prettyDateOptions) : null); 
  }
  
  function getThisWeekendDateRange() {
    return weekendDateRangeFromDate(new Date());
  }
  
  function getNextWeekendDateRange() {
    var nextWeek = new Date();
    nextWeek.setUTCDate(nextWeek.getUTCDate() + 7);
    return weekendDateRangeFromDate(nextWeek);
  }
  
  function getThisMonthDateRange() {
    var endOfMonth = new Date();
    
    // "This month" means 31 days from today
    endOfMonth.setUTCDate(endOfMonth.getUTCDate() + 31);
    return getDateRangeStructure(new Date, endOfMonth);
  }
  
  function updateStartDate(val) {
    updateDateRangeFromStrings(val, $endDateFilter.val());
  }
  
  function updateEndDate(val) {
    updateDateRangeFromStrings($startDateFilter.val(), val);
  }
  
  function updateDateRangeFromStructure(structure) {
    updateDateRangeFromStrings(structure.start, structure.end);
  }
  
  function resetDates() {
    updateDateRangeFromStrings('', '');
  }
  
  /**
   * Updates the filter inputs and refreshes the results.
   * 
   * @param start string E.g. 2019-08-21
   * @param end string E.g. 2019-10-30
   */
  function updateDateRangeFromStrings(start, end) {
    $startDateFilter.val(start);
    $endDateFilter.val(end);
    refreshResults();
  }
  
  function init() {
    if (initialized) { return; }
    initialized = true;
    
    $tourBrowser = $('#tourBrowser');
    $filterbar = $('#tourBrowser__filterbar');
    $pagination = $('#tourBrowser__pagination');
    $results = $('#tourBrowser__results');
    ensureAllToursExists();
    $selectedDates = $tourBrowser.find('.dateFilter__selectedDates');
    
    $catFilter = $('#catFilter');

    thisWeekendDateRange = getThisWeekendDateRange();
    $btnThisWeekend = $filterbar.find('button.dateFilter--thisWeekend');
    $btnThisWeekend.on('click', () => updateDateRangeFromStructure(thisWeekendDateRange));
    
    nextWeekendDateRange = getNextWeekendDateRange();
    $btnNextWeekend = $filterbar.find('button.dateFilter--nextWeekend');
    $btnNextWeekend.on('click', () => updateDateRangeFromStructure(nextWeekendDateRange));

    thisMonthDateRange = getThisMonthDateRange();
    $btnThisMonth = $filterbar.find('button.dateFilter--thisMonth');
    $btnThisMonth.on('click', () => updateDateRangeFromStructure(thisMonthDateRange));

    $startDateFilter = $filterbar.find('.dateFilter--startDate');
    $endDateFilter = $filterbar.find('.dateFilter--endDate');

    $catFilter.on('changex', refreshResults);
    $startDateFilter.on('change', refreshResults);
    $endDateFilter.on('change', refreshResults);
    
    $selectedDates.find('#btnDateReset').on('click', resetDates);
    
    // Start loading the tours into the cache.
    loadNextPage();

    if (window.BD.weekdayTourData) {    
      loadWeekdayProduct();
      
      let weekdayBlackoutStrings = window.BD.weekdayTourData.blackoutDates;
      const leadTimeDays = window.BD.weekdayTourData.leadTimeDays || 0;
      const firstAvailableDate = window.moment().add(leadTimeDays, "days");
      const leadTimeBlackout = `2020-01-01 - ${ firstAvailableDate.utc().format('YYYY-MM-DD') }`;
      
      weekdayBlackoutStrings += "\n" + leadTimeBlackout;
      weekdayBlackouts = new window.BD.BlackoutDates(weekdayBlackoutStrings);
      weekdayBlackouts.dateRangeJoin = 'thru';
    }
  }
  
  return {
    init: init,
    $allTours,
    onLoadingComplete,
    updateStartDate: updateStartDate,
    updateEndDate: updateEndDate
  };
})(jQuery);